module.exports = __webpack_public_path__ + "static/media/microscope-vga.2d6cee8c.jpg";